import { SvgIconProps } from "@mui/material/SvgIcon";
import StyledSvgIconWrapper from "./wrappers/StyledSvgIconWrapper";

export const SharedReceivedIcon = (props: SvgIconProps) => {
  return (
    <StyledSvgIconWrapper {...props} width="30" height="30" viewBox="0 0 30 30">
      <svg width="33" height="29" viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_260_109)">
          <path
            d="M4.19 18.47L7.46 14.31L4.19 10.16"
            stroke="#32B88E"
            strokeWidth="1.89"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.42 7.19995C8.78 3.43995 12.97 0.949951 17.74 0.949951C25.12 0.949951 31.11 6.92995 31.11 14.32C31.11 21.71 25.13 27.69 17.74 27.69C12.97 27.69 8.79 25.2 6.42 21.44"
            stroke="#32B88E"
            strokeWidth="1.89"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.07 21.06C25.07 21.06 25.07 11.51 20.7 11.51C16.57 11.51 15.38 21.06 18.21 21.06C21.3 21.06 20.19 11.51 15.3 11.51C10.41 11.51 10.67 21.06 10.67 21.06"
            stroke="#32B88E"
            strokeWidth="1.89"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.04 9.50003C15.9623 9.50003 16.71 8.75235 16.71 7.83003C16.71 6.90772 15.9623 6.16003 15.04 6.16003C14.1177 6.16003 13.37 6.90772 13.37 7.83003C13.37 8.75235 14.1177 9.50003 15.04 9.50003Z"
            fill="#32B88E"
          />
          <path
            d="M20.7 9.50003C21.6223 9.50003 22.37 8.75235 22.37 7.83003C22.37 6.90772 21.6223 6.16003 20.7 6.16003C19.7777 6.16003 19.03 6.90772 19.03 7.83003C19.03 8.75235 19.7777 9.50003 20.7 9.50003Z"
            fill="#32B88E"
          />
          <path
            d="M7.46 14.3101H0.949997"
            stroke="#32B88E"
            strokeWidth="1.89"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_260_109">
            <rect width="32.05" height="28.63" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </StyledSvgIconWrapper>
  );
};
